import { Pipe, PipeTransform } from '@angular/core';
import { SupplierProfile } from '../models/supplier-profile';

@Pipe({
  standalone: false,
  name: 'supplierProfileFilter',
})
export class SupplierProfileFilterPipe implements PipeTransform {
  transform(
    suppliers: SupplierProfile[] | null,
    search: string
  ): SupplierProfile[] {
    var result = suppliers!.filter((item: SupplierProfile) => {
      return (
        item.vendCode.toLowerCase().includes(search.toLowerCase()) ||
        item.vendDescription!.toLowerCase().includes(search.toLowerCase()) ||
        item.plantCode.toLowerCase().includes(search.toLowerCase()) ||
        item.plantDescription!.toLowerCase().includes(search.toLowerCase())
      );
    });
    return result;
  }
}

